<template>
  <div class="row">&nbsp;</div>
  <div v-if="this.page_permission === 'Y'">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="row">
            <!-- <WelcomeCard /> -->
            <div class="col-xxl-12">
              <div class="row widget-grid">
                <div class="card profile-box">
                  <div class="card-body">
                    <div class="media">
                      <div class="media-body">
                        <div class="greeting-user">
                          <h4 class="f-w-600 mb-0">
                            <vue-feather
                              type="bar-chart"
                              size="36"
                            ></vue-feather>
                             DASHBOARD
                          </h4>
                          <p>&nbsp;</p>
                          <!-- <p>{{ this.eventDetails.event_date }},{{ this.eventDetails.province }}</p> -->

                          <p>&nbsp;</p>
                          <p>&nbsp;</p>
                        </div>
                      </div>
                    </div>
                    <div class="cartoon">
                      <img
                        class="img-fluid"
                        src="@/assets/images/dashboard/cartoon.svg"
                        alt="vector women with leptop"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 v-if="this.user.role_name === 'system' || this.user.role_name === 'systemadmin'" class="m-0" >
                  <b
                    >Tag Proces
                    <a :href="'/event-adjustment-admin/' + this.$route.params.q"
                      >[กิจกรรม/ช่างภาพ]</a
                    ></b
                  >
                </h5>
                <h5 v-else class="m-0">
                  <b
                    >Tag Proces
                    <a :href="'/event-adjustment/' + this.$route.params.q"
                      >[กิจกรรม/ช่างภาพ]</a
                    ></b
                  >
                </h5>
                <button
                  type="button"
                  @click.prevent="systemTagProcess(),systemTagProcessVideo()"
                  class="btn btn-primary"
                >
                  <vue-feather type="refresh-cw" size="18"> </vue-feather>
                  Refresh
                </button>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center"><b>วันที่จัดกิจกรรม</b></th>
                    <th style="text-align: left"><b>กิจกรรม</b></th>
                    <th style="text-align: center"><b>รูปทั้งหมด</b></th>
                    <th style="text-align: center"><b>แท็กแล้ว</b></th>
                    <th style="text-align: center"><b>กำลังแท็ก</b></th>
                  </tr>
                </thead>
                <tbody v-if="this.loadding_tag_process === 'Y'">
                  <tr>
                    <td colspan="6">
                      <div class="d-flex justify-content-center">
                        <img
                          style="align-items: center; width: 60px"
                          src="../../assets/images/running_loading.svg"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
                
                <tbody
                  v-if="
                    this.data_tag_process.length === 0 &&
                    this.loadding_tag_process === 'N'
                  "
                >
                  <tr>
                    <td colspan="6">
                      <div class="d-flex justify-content-center">
                        ไม่พบข้อมูล
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.data_tag_process.length !== 0">
                  <tr v-for="item in this.data_tag_process" :key="item">
                    <td scope="row" style="text-align: center">
                      {{ item.event_date }}
                    </td>
                    <td scope="row" style="text-align: left">
                      [IMAGE] {{ item.title }}
                    </td>
                    <td scope="row" style="text-align: center">
                      {{ Number(item.taged) + Number(item.process) }}
                    </td>
                    <td scope="row" style="text-align: center">
                      {{ item.taged }}
                    </td>
                    <td scope="row" style="text-align: center">
                      {{ item.process }}
                    </td>
                  </tr>
                </tbody>
                
                <!-- Video Tag Process -->
                <tbody v-if="this.is_enable_vdo === 'Y'">
                  <tr v-for="item in this.data_tag_process_video" :key="item">
                    <td scope="row" style="text-align: center">
                      {{ item.event_date }}
                    </td>
                    <td scope="row" style="text-align: left">
                      [VIDEO] {{ item.title }}
                    </td>
                    <td scope="row" style="text-align: center">
                      {{ Number(item.taged) + Number(item.process) }}
                    </td>
                    <td scope="row" style="text-align: center">
                      {{ item.taged }}
                    </td>
                    <td scope="row" style="text-align: center">
                      {{ item.process }}
                    </td>
                  </tr>
                </tbody>

              </table>
            </div>

            
          </div>
        </div>
        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>สรุปยอดสั่งซื้อ</b></h5>
                <button
                  type="button"
                  @click.prevent="reportSymmery()"
                  class="btn btn-primary"
                >
                  <vue-feather type="refresh-cw" size="18"> </vue-feather>
                  Refresh
                </button>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center"><b>วันที่จัดกิจกรรม</b></th>
                    <th style="text-align: left"><b>กิจกรรม</b></th>
                    <th style="text-align: center"><b>รายรับ</b></th>
                    <th style="text-align: center"><b>ภาษีมูลค่าเพิ่ม</b></th>
                    <th style="text-align: center"><b>รายได้หลักหักภาษี</b></th>
                    <th style="text-align: center"><b>ส่วนแบ่งช่างภาพ</b></th>
                    <th style="text-align: center"><b>ออเดอร์</b></th>
                    <th style="text-align: center"><b>รูปที่ขาย</b></th>
                    <th style="text-align: center"><b>ส่วนแบ่งผู้จัด</b></th>
                    <th style="text-align: center"><b>ส่วนแบ่งผู้ดูแล</b></th>
                    <th style="text-align: center"><b>ส่วนแบ่งระบบ</b></th>
                  </tr>
                </thead>
                <tbody v-if="this.loadding_report_summery === 'Y'">
                  <tr>
                    <td colspan="16">
                      <div class="d-flex justify-content-center">
                        <img
                          style="align-items: center; width: 60px"
                          src="../../assets/images/running_loading.svg"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-if="
                    this.data_report_summery.length === 0 &&
                    this.loadding_report_summery === 'N'
                  "
                >
                  <tr>
                    <td colspan="16">
                      <div class="d-flex justify-content-center">
                        ไม่พบข้อมูล
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.data_report_summery.length !== 0">
                  <tr v-for="item in this.data_report_summery" :key="item">
                    <td style="text-align: center">
                      {{ item.event_date }}
                    </td>
                    <td scope="row" style="text-align: left">
                      {{ item.title }}
                    </td>
                    <td style="text-align: center">
                      100% <br />
                      {{ Number(item.amount).toFixed(2) }}
                    </td>
                    <td style="text-align: center">
                      <!-- {{ item.vat }}% --><br /> 
                      {{ item.net_vat }}
                    </td>
                    <td style="text-align: center">
                      100% <br />
                      {{ Number(item.amount-item.net_vat).toFixed(2) }}
                    </td>
                    <td style="text-align: center">
                      {{ item.photographer_share }}% <br />
                      {{ Number(item.net_photographer).toFixed(2) }}
                    </td>
                    <td style="text-align: center">
                      {{ item.order_count }}
                    </td>
                    <td style="text-align: center">
                      {{ item.photo_count }}
                    </td>
                    <td style="text-align: center">
                      {{ item.organizer_share }}% <br />{{
                        item.organizershare_amt
                      }}
                    </td>
                    <td style="text-align: center">
                      {{ item.salespersonshare }}% <br />{{
                        item.salespersonshare_amt
                      }}
                    </td>
                    <td style="text-align: center">
                      {{ item.system_share }}% <br />{{ item.system_amt }}
                    </td>
                  </tr>
                </tbody>

                <tbody v-if="this.data_report_summery.length !== 0">
                  <tr v-for="item in this.data_report_summery" :key="item">
                    <td
                      colspan="16"
                      style="text-align: left; font-size: xx-small"
                      v-if="item.is_mhao === 'Y' || item.is_mhao_hybrid === 'Y'"
                    >
                      <span v-if="this.system_prefix === 'SA'">
                      <span v-html="item.txt_note"></span>
                      </span>
                      <span v-else >
                        <span v-html="item.txt_note"></span>
                      </span>
                      <hr v-if="this.data_get_round_one_amt.round1_amt===null">
                      <button type="button" v-if="this.data_get_round_one_amt.round1_amt===null"
                          @click.prevent="saveRoundOneAmt(Number(
                              item.net_photographer +
                                item.organizershare_amt +
                                item.salespersonshare_amt 
                            ).toFixed(2),item.net_vat,
                             item.txt_note, 
                             item.net_photographer,
                             item.organizershare_amt,
                             item.salespersonshare_amt,
                             item.system_amt)"
                          class="btn btn-primary"
                        >
                          <vue-feather type="save" size="18"> </vue-feather>
                          ตัดรอบแรกงานเหมา
                        </button><br>
                    </td>
                  </tr>
                  <tr v-for="item in this.data_report_summery" :key="item">
                    <td
                      colspan="16"
                      style="text-align: left; font-size: xx-small"
                      v-if="(item.is_mhao === 'Y' || item.is_mhao_hybrid === 'Y') && this.data_get_round_one_amt.round1_amt !== null"
                    >
                    <span v-if="this.system_prefix === 'SA'" >
                     
                    <b>*Note: ข้อมูลการตัดรอบโอน รอบแรก</b><br>
                      ยอดโอนรวม(ยอดขาย,ผู้จัด,ผู้ดูแล): {{ Number(this.data_get_round_one_amt.round1_amt).toFixed(2) }}<br />
                      ยอดโอนรวม(vat): {{ Number(this.data_get_round_one_amt.round1_vat).toFixed(2) }}<br />
                      วันที่ทำรายการ: {{ this.data_get_round_one_amt.round1_create_date }}<br />
                      Note: {{system_prefix}}{{ this.data_get_round_one_amt.round1_user_id }}<br />
                      <hr>
                           <span>   
                          ส่วนต่างโอนเพิ่มรอบสอง (ยอดขาย,ผู้จัด,ผู้ดูแล) {{ ((Number((
                              item.net_photographer +
                                item.organizershare_amt +
                                item.salespersonshare_amt
                            ))-this.data_get_round_one_amt.round1_amt)).toFixed(2) }}

                          <br>
                          ส่วนต่างโอนเพิ่มรอบสอง (vat): {{ (((Number(
                                item.net_vat
                            )- (this.data_get_round_one_amt.round1_vat) ))).toFixed(2) }}
                            <br>
                          <u>ส่วนต่างโอนเพิ่มรอบสอง(ทั้งหมด) {{ ((Number(
                              item.net_photographer +
                                item.organizershare_amt +
                                item.salespersonshare_amt +
                                item.net_vat
                            )-this.data_get_round_one_amt.round1_amt-this.data_get_round_one_amt.round1_vat)).toFixed(2) }}</u><br />
                           
                          
                          
                          
                          <hr>
                          <button type="button" v-if="this.data_get_round_one_amt.round2_amt===null"
                          @click.prevent="saveRoundTwoAmt(((Number(
                              item.net_photographer +
                                item.organizershare_amt +
                                item.salespersonshare_amt 
                            )-this.data_get_round_one_amt.round1_amt)).toFixed(2),
                            Number(item.net_vat-this.data_get_round_one_amt.round1_vat).toFixed(2),
                            item.txt_note,
                            Number(item.net_photographer-this.data_get_round_one_amt.round1_photographer_share).toFixed(2),
                            Number(item.organizershare_amt-this.data_get_round_one_amt.round1_organizer_share).toFixed(2),
                            Number(item.salespersonshare_amt-this.data_get_round_one_amt.round1_sale_share).toFixed(2),
                            Number(item.system_amt-this.data_get_round_one_amt.round1_system_share).toFixed(2)
                          )"
                          class="btn btn-primary"
                        >
                          <vue-feather type="check-circle" size="18"> </vue-feather>
                        ปิดยอดโอนงานเหมา #2
                        </button>
                        <p v-if="this.data_get_round_one_amt.round2_amt!==null"  style="color: green;">
                          ยอดปิดรอบสอง: {{ Number(this.data_get_round_one_amt.round2_amt).toFixed(2) }}<br />
                          ยอดปิดรอบสอง(Vat): {{ Number(this.data_get_round_one_amt.round2_vat).toFixed(2) }}<br />
                          ยอดปิดรอบสอง(รวม): {{ (Number(this.data_get_round_one_amt.round2_amt) + Number(this.data_get_round_one_amt.round2_vat)).toFixed(2) }}<br />
                          วันที่: {{ this.data_get_round_one_amt.round2_create_date }}<br />
                          Note: {{ this.data_get_round_one_amt.round2_user_id }}<br />
                        </p>
                        <h5 v-if="this.data_get_round_one_amt.round2_amt!==null"  style="color: green;"><vue-feather type="check-circle"  size="18"> </vue-feather> ปิดยอดงานเหมาเรียบร้อย</h5>
                        <br>
                        </span>
                    </span>
                    <span v-else >
                    <b>*Note: ข้อมูลการตัดรอบโอน รอบแรก</b><br>
                      ยอดโอนรวม(ยอดขาย,ผู้จัด,ผู้ดูแล): {{ Number(this.data_get_round_one_amt.round1_amt).toFixed(2) }}<br />
                      ยอดโอนรวม(vat): {{ Number(this.data_get_round_one_amt.round1_vat).toFixed(2) }}<br />
                      วันที่ทำรายการ: {{ this.data_get_round_one_amt.round1_create_date }}<br />
                      Note: {{system_prefix}}{{ this.data_get_round_one_amt.round1_user_id }}<br />
                      <hr>
                           <span v-if="this.system_prefix ==='SA' || this.system_prefix ==='ER'">   
                          ส่วนต่างโอนเพิ่มรอบสอง (ยอดขาย,ผู้จัด,ผู้ดูแล) {{ ((Number((
                              item.net_photographer +
                                item.organizershare_amt +
                                item.salespersonshare_amt
                            ))-this.data_get_round_one_amt.round1_amt)).toFixed(2) }}

                          <br>
                          ส่วนต่างโอนเพิ่มรอบสอง (vat): {{ (((Number(
                                item.net_vat
                            )- (this.data_get_round_one_amt.round1_vat) ))).toFixed(2) }}
                            <br>
                          <u>ส่วนต่างโอนเพิ่มรอบสอง(ทั้งหมด) {{ ((Number(
                              item.net_photographer +
                                item.organizershare_amt +
                                item.salespersonshare_amt +
                                item.net_vat
                            )-this.data_get_round_one_amt.round1_amt-this.data_get_round_one_amt.round1_vat)).toFixed(2) }}</u><br />
                           
                          
                          
                          
                          <hr>
                          <button type="button" v-if="this.data_get_round_one_amt.round2_amt===null"
                          @click.prevent="saveRoundTwoAmt(((Number(
                              item.net_photographer +
                                item.organizershare_amt +
                                item.salespersonshare_amt 
                            )-this.data_get_round_one_amt.round1_amt)).toFixed(2),
                            Number(item.net_vat-this.data_get_round_one_amt.round1_vat).toFixed(2),
                            item.txt_note,
                            Number(item.net_photographer-this.data_get_round_one_amt.round1_photographer_share).toFixed(2),
                            Number(item.organizershare_amt-this.data_get_round_one_amt.round1_organizer_share).toFixed(2),
                            Number(item.salespersonshare_amt-this.data_get_round_one_amt.round1_sale_share).toFixed(2),
                            Number(item.system_amt-this.data_get_round_one_amt.round1_system_share).toFixed(2)
                          )"
                          class="btn btn-primary"
                        >
                          <vue-feather type="check-circle" size="18"> </vue-feather>
                        ปิดยอดโอนงานเหมา #2
                        </button>
                        <p v-if="this.data_get_round_one_amt.round2_amt!==null"  style="color: green;">
                          ยอดปิดรอบสอง: {{ Number(this.data_get_round_one_amt.round2_amt).toFixed(2) }}<br />
                          ยอดปิดรอบสอง(Vat): {{ Number(this.data_get_round_one_amt.round2_vat).toFixed(2) }}<br />
                          ยอดปิดรอบสอง(รวม): {{ (Number(this.data_get_round_one_amt.round2_amt) + Number(this.data_get_round_one_amt.round2_vat)).toFixed(2) }}<br />
                          วันที่: {{ this.data_get_round_one_amt.round2_create_date }}<br />
                          Note: {{ this.data_get_round_one_amt.round2_user_id }}<br />
                        </p>
                        <h5 v-if="this.data_get_round_one_amt.round2_amt!==null"  style="color: green;"><vue-feather type="check-circle"  size="18"> </vue-feather> ปิดยอดงานเหมาเรียบร้อย</h5>
                        <br>
                        </span>
                        <span v-else >
                          <b>Note: [{{ item.event_date }}] {{ item.title }}: {{ item.date_now }}<br></b>
                          ส่วนต่างโอนเพิ่มรอบสอง (ยอดขาย,ผู้จัด,ผู้ดูแล) {{ ((Number((
                              item.net_photographer +
                                item.organizershare_amt +
                                item.salespersonshare_amt
                            ))-this.data_get_round_one_amt.round1_amt)).toFixed(2) }}

                          <br>
                          Omise: {{ ((Number((
                              item.net_photographer +
                                item.organizershare_amt +
                                item.salespersonshare_amt
                            ))-this.data_get_round_one_amt.round1_amt)).toFixed(2) }}+20(ระบบออกให้)=
                            <b>*{{ (((Number((
                              item.net_photographer +
                                item.organizershare_amt +
                                item.salespersonshare_amt
                            ))-this.data_get_round_one_amt.round1_amt))+20).toFixed(2) }}*</b>
                  
                          </span>
                    </span>
                  
                  </td>
                    
                  </tr>
                 
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>สรุปข้อมูลช่างภาพ</b></h5>
                <button
                  type="button"
                  @click.prevent="loadOrderImageByUser()"
                  class="btn btn-primary"
                >
                  <vue-feather type="refresh-cw" size="18"> </vue-feather>
                  Refresh
                </button>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center"><b>ลำดับ</b></th>
                    <th style="text-align: center"><b>รหัสช่างภาพ</b></th>
                    <th style="text-align: left"><b>ชื่อ</b></th>
                    <th style="text-align: center"><b>จำนวนที่อัปโหลด</b></th>
                    <th style="text-align: center"><b>แท็กแล้ว</b></th>
                    <th style="text-align: center"><b>จำนวนยอดขาย</b></th>
                    <th style="text-align: center"><b>จำนวนยอดขาย(%)</b></th>
                  </tr>
                </thead>
                <tbody v-if="this.loadding_order_image_by_user === 'Y'">
                  <tr>
                    <td colspan="7">
                      <div class="d-flex justify-content-center">
                        <img
                          style="align-items: center; width: 60px"
                          src="../../assets/images/running_loading.svg"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-if="
                    this.data_order_image_by_user.length === 0 &&
                    this.loadding_order_image_by_user === 'N'
                  "
                >
                  <tr>
                    <td colspan="7">
                      <div class="d-flex justify-content-center">
                        ไม่พบข้อมูล
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.data_order_image_by_user.length !== 0">
                  <tr
                    v-for="(item, index) in this.data_order_image_by_user"
                    :key="item"
                  >
                    <td scope="row" style="text-align: center">
                      {{ index + 1 }}
                    </td>
                    <td scope="row" style="text-align: center">
                      {{ item.user_id_text }}
                    </td>
                    <td style="text-align: left">
                      {{ item.display_name }}
                    </td>
                    <td style="text-align: center" :class="{ 'text-danger': hasUploadMismatch(item) }">
                      {{ item.image_upload_count }}
                    </td>
                    <td style="text-align: center" :class="{ 'text-danger': hasUploadMismatch(item) }">
                      {{ item.image_upload_count_tag }}
                      <div v-if="hasUploadMismatch(item)" class="small">
                        (diff: {{ Number(item.image_upload_count) - Number(item.image_upload_count_tag) }})
                      </div>
                    </td>
                    <td style="text-align: center">
                      {{ item.image_sale_count }}
                    </td>
                    <td style="text-align: center">
                      {{ Number(item.percen).toFixed(2) }}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-xl-12" v-if="this.is_enable_vdo === 'Y'">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>สรุปข้อมูลช่างภาพ [VIDEO]</b></h5>
                <button
                  type="button"
                  @click.prevent="loadOrderVideoByUser()"
                  class="btn btn-primary"
                >
                  <vue-feather type="refresh-cw" size="18"> </vue-feather>
                  Refresh
                </button>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center"><b>ลำดับ</b></th>
                    <th style="text-align: center"><b>รหัสช่างภาพ</b></th>
                    <th style="text-align: left"><b>ชื่อ</b></th>
                    <th style="text-align: center"><b>จำนวนที่อัปโหลด</b></th>
                    <th style="text-align: center"><b>จำนวนยอดขาย</b></th>
                    <th style="text-align: center"><b>จำนวนยอดขาย(%)</b></th>
                  </tr>
                </thead>
                <tbody v-if="this.loadding_order_video_by_user === 'Y'">
                  <tr>
                    <td colspan="6">
                      <div class="d-flex justify-content-center">
                        <img
                          style="align-items: center; width: 60px"
                          src="../../assets/images/running_loading.svg"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-if="
                    this.data_order_video_by_user.length === 0 &&
                    this.loadding_order_video_by_user === 'N'
                  "
                >
                  <tr>
                    <td colspan="6">
                      <div class="d-flex justify-content-center">
                        ไม่พบข้อมูล
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.data_order_video_by_user.length !== 0">
                  <tr
                    v-for="(item, index) in this.data_order_video_by_user"
                    :key="item"
                  >
                    <td scope="row" style="text-align: center">
                      {{ index + 1 }}
                    </td>
                    <td scope="row" style="text-align: center">
                      {{ item.user_id_text }}
                    </td>
                    <td style="text-align: left">
                      {{ item.display_name }}
                    </td>
                    <td style="text-align: center">
                      {{ item.image_upload_count }}
                    </td>
                    <td style="text-align: center">
                      {{ is_apisitchu ? item.image_sale_count : '-' }}
                    </td>
                    <td style="text-align: center">
                      {{ is_apisitchu ? Number(item.percen).toFixed(2) : '-' }}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-xl-12" v-if="this.is_mhao === 'Y'">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>ข้อมูลสรุปคะแนนช่างภาพ</b></h5>
                <br />

                <button
                  type="button"
                  @click.prevent="reportPerformance()"
                  class="btn btn-primary"
                >
                  <vue-feather type="refresh-cw" size="18"> </vue-feather>
                  Refresh
                </button>
              </div>
              <p style="text-align: left; font-size: xx-small">
                <ui>
                  <li>มีรูปที่ขายได้ใน Order เหมา นับ 1 คะแนน</li>
                  <li>มีรูปที่ขายได้ใน Order แยก นับรูปละ 1 คะแนน</li>
                </ui>
              </p>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center"><b>ลำดับ</b></th>
                    <th style="text-align: center"><b>รหัสช่างภาพ</b></th>
                    <th style="text-align: left"><b>ช่างภาพ</b></th>
                    <th style="text-align: center"><b>ออเดอร์แยก</b></th>
                    <th style="text-align: center"><b>ออเดอร์เหมา</b></th>
                    <th style="text-align: center"><b>รวมคะแนน</b></th>
                  </tr>
                </thead>
                <tbody v-if="this.loadding_report_performance === 'Y'">
                  <tr>
                    <td colspan="6">
                      <div class="d-flex justify-content-center">
                        <img
                          style="align-items: center; width: 60px"
                          src="../../assets/images/running_loading.svg"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-if="
                    this.data_report_performance.length === 0 &&
                    this.loadding_report_performance === 'N'
                  "
                >
                  <tr>
                    <td colspan="6">
                      <div class="d-flex justify-content-center">
                        ไม่พบข้อมูล
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.data_report_performance.length !== 0">
                  <tr
                    v-for="(item, index) in this.data_report_performance"
                    :key="item"
                  >
                    <td scope="row" style="text-align: center">
                      {{ index + 1 }}
                    </td>
                    <td scope="row" style="text-align: center">
                      {{ item.user_id_text }}
                    </td>
                    <td style="text-align: left">
                      {{ item.display_name }}
                    </td>
                    <td style="text-align: center">
                      {{ item.score - item.mhao_score }}
                    </td>
                    <td style="text-align: center">
                      {{ item.mhao_score }}
                    </td>
                    <td style="text-align: center">
                      {{ item.score }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0">
                  <b>ข้อมูลสรุปยอดขายตามจำนวนภาพของออเดอร์</b>
                </h5>
                <br />

                <button
                  type="button"
                  @click.prevent="reportOrderSummery()"
                  class="btn btn-primary"
                >
                  <vue-feather type="refresh-cw" size="18"> </vue-feather>
                  Refresh
                </button>
              </div>
              <p style="text-align: left; font-size: xx-small">
                <ui>
                  <li>ยอดขายแบ่งตามจำนวนภาพภายในออเดอร์</li>
                  <li v-if="this.is_mhao === 'Y'">
                    special condition คือออเดอร์ที่สร้างโดยระบบเพิ่มเติม
                    อาทิเช่น <br />&nbsp;&nbsp;&nbsp;&nbsp; > นักวิ่งเหมาแล้ว
                    และส่งรูปเพิ่มเติมให้นักวิ่ง หรือ ช่างภาพ upload
                    เข้ามาในระบบหลังจากนักวิ่งเหมาไปแล้ว
                    ระบบสร้างออเดอร์เพื่อส่งรูปเพิ่มเติมให้กับนักวิ่ง
                    <br />&nbsp;&nbsp;&nbsp;&nbsp; >
                    ออเดอร์พิเศษให้กับผู้จัดกิจกรรม
                    ตามเงือนไขที่ตกลงกับผู้จัดแต่ละกิจกรรม(ถ้ามี)
                  </li>
                </ui>
              </p>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center"><b>ลำดับ</b></th>
                    <th style="text-align: center"><b>ราคาขาย</b></th>
                    <th style="text-align: center"><b>จำนวนออเดอร์</b></th>
                    <th style="text-align: center"><b>จำนวนรูป</b></th>
                    <th style="text-align: center"><b>ยอดขาย</b></th>
                    <th style="text-align: center"><b>หมายเหตุ</b></th>
                  </tr>
                </thead>
                <tbody v-if="this.loadding_report_order_summery === 'Y'">
                  <tr>
                    <td colspan="6">
                      <div class="d-flex justify-content-center">
                        <img
                          style="align-items: center; width: 60px"
                          src="../../assets/images/running_loading.svg"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-if="
                    this.data_report_order_summery.length === 0 &&
                    this.loadding_report_order_summery === 'N'
                  "
                >
                  <tr>
                    <td colspan="6">
                      <div class="d-flex justify-content-center">
                        ไม่พบข้อมูล
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.data_report_order_summery.length !== 0">
                  <tr
                    v-for="(item, index) in this.data_report_order_summery"
                    :key="item"
                  >
                    <td scope="row" style="text-align: center">
                      {{ index + 1 }}
                    </td>
                    <td scope="row" style="text-align: center">
                      {{ item.amount }}
                    </td>
                    <td style="text-align: center">
                      {{ item.order_count }}
                    </td>
                    <td style="text-align: center">
                      {{
                            item.is_mhao === "Y"
                              ? "&infin;"
                              : item.amount === this.mhao_price &&
                                item.is_mhao === "N"
                              ? "&infin;"
                              : item.image_length
                          }}
                    </td>

                    <td style="text-align: center">
                      {{ Number(item.amount * item.order_count).toFixed(2) }}
                    </td>
                    <td
                      scope="row"
                      style="text-align: left; font-size: xx-small"
                    >
                      {{
                        item.amount === 0
                          ? "[special condition]"
                          : item.amount === this.mhao_price &&
                            item.is_mhao === "Y"
                          ? "แพ็กเกจ เหมา"
                          : item.amount === this.mhao_price &&
                            item.is_mhao === "N"
                          ? "เลือกรูปเกินราคาเหมา"
                          : "-"
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>


        <div class="col-xl-12" v-if="this.user.role_name === 'systemadmin'">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>รายงานข้อมูลระบบ</b></h5>
                <button
                  type="button"
                  @click.prevent="facesearchCount()"
                  class="btn btn-primary"
                >
                  <vue-feather type="refresh-cw" size="18"> </vue-feather>
                  Refresh
                </button>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: center"><b>ลำดับ</b></th>
                    <th style="text-align: left"><b>Service</b></th>
                    <th style="text-align: center"><b>จำนวน</b></th>
                  </tr>
                </thead>
                <tbody v-if="this.loadding_facesearch_count === 'Y'">
                  <tr>
                    <td colspan="3">
                      <div class="d-flex justify-content-center">
                        <img
                          style="align-items: center; width: 60px"
                          src="../../assets/images/running_loading.svg"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody
                  v-if="
                    this.data_facesearch_count.length === 0 &&
                    this.loadding_facesearch_count === 'N'
                  "
                >
                  <tr>
                    <td colspan="3">
                      <div class="d-flex justify-content-center">
                        ไม่พบข้อมูล
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.data_facesearch_count.length !== 0">
                  <tr
                    v-for="(item, index) in this.data_facesearch_count"
                    :key="item"
                  >
                    <td scope="row" style="text-align: center">
                      {{ index + 1 }}
                    </td>
                    <td style="text-align: left">
                      {{ item.service }}
                    </td>
                    <td style="text-align: center">
                      {{ item.service_count }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-xl-12">
          <div class="card bank-card">
            <div class="card-header bank-card-header">
              <div class="bank-header-left">
                <span class="bank-header-icon">
                  <vue-feather type="credit-card" size="20"></vue-feather>
                </span>
                <div>
                  <h5 class="m-0"><b>หมายเลขบัญชีช่างภาพ</b></h5>
                  <small class="text-muted">ข้อมูลบัญชีสำหรับโอนเงินและติดต่อช่างภาพ</small>
                </div>
              </div>
              <div class="bank-header-right">
                <div v-if="this.user.role_name === 'systemadmin'" class="form-check form-switch m-0">
                  <input class="form-check-input" type="checkbox" role="switch" id="chk_show_bank_info" v-model="show_bank_info">
                  <label class="form-check-label" for="chk_show_bank_info">สำหรับบัญชี</label>
                </div>
                <button
                  type="button"
                  @click.prevent="reportAccount()"
                  class="btn btn-primary"
                >
                  <vue-feather type="refresh-cw" size="18"> </vue-feather>
                  Refresh
                </button>
              </div>
            </div>

            <div class="card-body">
              <div v-if="this.data_report_account.length === 0" class="bank-empty">
                <vue-feather type="inbox" size="26"></vue-feather>
                <span>กด Refresh เพื่อโหลดข้อมูลบัญชี</span>
              </div>

              <div v-else class="bank-blocks">
                <div class="bank-block">
                  <div class="bank-block-head">
                    <span class="bank-block-title">
                      <vue-feather type="copy" size="15"></vue-feather> สำหรับคัดลอกส่งโอนเงินให้ช่างภาพ
                    </span>
                  </div>
                  <div class="bank-block-body">
                    <div v-for="item in this.data_report_account" :key="item" class="bank-line">
                      {{item.user_role}}{{item.prefix}}-{{ item.display_name }}-{{ item.bank_account_name }}-{{ item.bank_name }}-{{ item.bank_account_no }}
                    </div>
                  </div>
                </div>

                <div class="bank-block">
                  <div class="bank-block-head">
                    <span class="bank-block-title">
                      <vue-feather type="phone" size="15"></vue-feather> สำหรับติดต่อ
                    </span>
                  </div>
                  <div class="bank-block-body">
                    <div v-for="item in this.data_report_account" :key="item" class="bank-line">
                      {{item.user_role}}{{item.prefix}}-{{ item.display_name }}-{{ item.bank_account_name }}-{{ item.bank_name }}-{{ item.bank_account_no }} tell:{{ item.mobile_no }}, line:{{ item.line_id }}
                    </div>
                  </div>
                </div>

                <div v-if="show_bank_info" class="bank-block">
                  <div class="bank-block-head">
                    <span class="bank-block-title">
                      <vue-feather type="shield" size="15"></vue-feather> สำหรับบัญชี
                    </span>
                  </div>
                  <div class="table-responsive">
                    <table class="table bank-table align-middle">
                      <thead>
                        <tr>
                          <th style="text-align: left">ชื่อ</th>
                          <th style="text-align: left">บัญชีธนาคาร</th>
                          <th style="text-align: center">หน้าสมุดบัญชีธนาคาร</th>
                          <th style="text-align: center">เลขที่บัตรประชาชน</th>
                          <th style="text-align: center">เอกสารแนบบัตรประชาชน</th>
                          <th style="text-align: center">สถานะยืนยันบัญชี</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in this.data_report_account" :key="item">
                          <td style="text-align: left">{{item.user_role}}{{item.prefix}}-{{ item.display_name }}</td>
                          <td style="text-align: left">{{ item.bank_account_name }}-{{ item.bank_name }}-{{ item.bank_account_no }}</td>
                          <td style="text-align: center">
                            <div v-if="item.bank_account_image_url" class="bank-img-thumb-row">
                              <div class="bank-img-thumb">
                                <img :src="`${aws_s3_url}${item.bank_account_image_url}`" />
                              </div>
                              <button
                                type="button"
                                class="btn btn-outline-primary btn-sm bank-dl-btn"
                                title="ดาวน์โหลด"
                                @click.prevent="downloadImage(item.bank_account_image_url)"
                              >
                                <vue-feather type="download" size="14"> </vue-feather>
                              </button>
                            </div>
                            <span v-else class="text-muted">-</span>
                          </td>
                          <td style="text-align: center">{{ item.id_card || '-' }}</td>
                          <td style="text-align: center">
                            <div v-if="item.id_card_image_url" class="bank-img-thumb-row">
                              <div class="bank-img-thumb">
                                <img :src="`${aws_s3_url}${item.id_card_image_url}`" />
                              </div>
                              <button
                                type="button"
                                class="btn btn-outline-primary btn-sm bank-dl-btn"
                                title="ดาวน์โหลด"
                                @click.prevent="downloadImage(item.id_card_image_url)"
                              >
                                <vue-feather type="download" size="14"> </vue-feather>
                              </button>
                            </div>
                            <span v-else class="text-muted">-</span>
                          </td>
                          <td style="text-align: center">
                            <span v-if="item.is_verify_account === 'Y'" class="verify-badge">
                              <vue-feather type="check-circle" size="14"> </vue-feather> ยืนยันแล้ว
                            </span>
                            <button
                              v-else
                              type="button"
                              class="btn btn-verify btn-sm"
                              @click.prevent="verifyAccount(item.user_id)"
                            >
                              <vue-feather type="check" size="14"> </vue-feather> ยืนยันบัญชี
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>

  <div v-if="this.page_permission === 'N'">
    <div class="d-flex justify-content-center">this page is not authorized</div>
  </div>
</template>
<style scoped>
.btn:disabled {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  color: #fff !important;
  opacity: 0.65;
  cursor: not-allowed !important;
}
.table-fit {
  width: 1px;
}

.bank-img-thumb {
  position: relative;
  display: inline-block;
}

.bank-img-thumb-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.bank-img-thumb img {
  height: 60px;
  border-radius: 6px;
  border: 1px solid #e5e9f2;
  position: relative;
  z-index: 1;
  transition: transform 0.18s ease;
}

.bank-img-thumb:hover {
  z-index: 200;
}

.bank-img-thumb:hover img {
  transform: scale(3);
  z-index: 200;
  background: #fff;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.45);
}

.bank-dl-btn {
  display: inline-flex;
  align-items: center;
  border-radius: 8px;
}

/* modern bank account card */
.bank-card {
  border: 1px solid #e8ecf4;
  border-radius: 14px;
  overflow: hidden;
}

.bank-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  background: linear-gradient(180deg, #f7f9fe 0%, #ffffff 100%);
  border-bottom: 1px solid #eef1f7;
}

.bank-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.bank-header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #eef2ff;
  color: #4f46e5;
}

.bank-header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.bank-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 30px 0;
  color: #94a3b8;
}

.bank-blocks {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.bank-block {
  border: 1px solid #eef1f7;
  border-radius: 12px;
  background: #fbfcfe;
  overflow: hidden;
}

.bank-block-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #f2f5fb;
  border-bottom: 1px solid #eaeef6;
}

.bank-block-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  font-size: 14px;
  color: #334155;
}

.bank-block-body {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.bank-line {
  font-size: 13px;
  color: #475569;
  word-break: break-word;
  padding: 4px 8px;
  border-radius: 6px;
}

.bank-line:hover {
  background: #eef2ff;
}

.bank-table {
  margin: 0;
}

.bank-table thead th {
  background: #f2f5fb;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
  border-bottom: 1px solid #e5e9f2;
}

.bank-table tbody tr:hover {
  background: #f8fafc;
}

/* soft primary verify button */
.btn-verify {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #eef2ff;
  color: #4f46e5;
  border: 1px solid #dbe2ff;
  border-radius: 8px;
  font-weight: 600;
  transition: background 0.18s ease, box-shadow 0.18s ease;
}

.btn-verify:hover {
  background: #e0e7ff;
  color: #4338ca;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.18);
}

.verify-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  background: #e8f7ee;
  color: #1e9e57;
}
</style>
<script>
import axios from "axios";
export default {
  data() {
    return {
      system_prefix: process.env.VUE_APP_SYSTEM_PREFIX,
      loadding: "N",
      loadding_order_image_by_user: "N",
      data_order_image_by_user: [],
      loadding_order_video_by_user: "N",
      data_order_video_by_user: [],

      loadding_tag_process: "N",
      data_tag_process: [],
      loadding_tag_process_video: "N",
      data_tag_process_video: [],

      loadding_report_summery: "N",
      data_report_summery: [],
      data_get_round_one_amt: {},

      loadding_report_performance: "N",
      data_report_performance: [],

      loadding_report_order_summery: "N",
      data_report_order_summery: [],

      loadding_facesearch_count: "N",
      data_facesearch_count: [],

      data_report_account: [],

      user: {},
      page_permission: null,
      is_mhao: "N",
      mhao_price: 1000,
      token: localStorage.getItem("jwt"),

      is_enable_vdo: "N",
      admin_user_id_apisitchu: parseInt(process.env.VUE_APP_ADMIN_USER_ID_APISITCHU),
      is_apisitchu: false,

      show_bank_info: false,
      aws_s3_url: process.env.VUE_APP_AWS_S3_URL,
    };
  },
  async created(){
    this.token = localStorage.getItem("jwt")
  },
  async mounted() {
    try {
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post("/v1/partner/permission", data, {
        headers
      });
      if (response.data.status === "success") {
        let bodyPermission = JSON.parse(JSON.stringify(response.data.body));
        this.page_permission = bodyPermission.permission;

        this.user = JSON.parse(localStorage.getItem("user"));

        if (this.page_permission === "Y") {
          await this.systemTagProcess();
          //this.loadOrderImageByUser();
          this.reportSymmery();
          //this.reportPerformance();
          //this.reportOrderSummery();
          if(parseInt(this.user.user_id) === this.admin_user_id_apisitchu){
            this.is_apisitchu = true;
          }

          if(this.is_enable_vdo === "Y"){
            this.systemTagProcessVideo();
            //this.loadOrderVideoByUser();
          }
        }
      } else {
        alert("permission is not recognized by admin");
      }
    } catch (error) {
      alert("login พบข้อผิดพลาด กรุณาแจ้งผู้ดูแลระบบ");
      //this.$router.push({ path: "/auth/login" });
    }
  },
  methods: {
    hasUploadMismatch(item) {
      return Number(item.image_upload_count) !== Number(item.image_upload_count_tag);
    },
    async loadOrderImageByUser() {
      this.loadding_order_image_by_user = "Y";
      this.data_order_image_by_user = [];
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/admin/running-order-image-by-user",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        this.data_order_image_by_user = response.data.body;

        this.loadding_order_image_by_user = "N";
      } else {
        alert("Load order พบข้อผิดพลาด!");
      }
    },
    async loadOrderVideoByUser() {
      this.loadding_order_video_by_user = "Y";
      this.data_order_video_by_user = [];
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/admin/running-order-video-by-user",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        this.data_order_video_by_user = response.data.body;

        this.loadding_order_video_by_user = "N";
      } else {
        alert("Load order พบข้อผิดพลาด!");
      }
    },

    async systemTagProcess() {
      this.loadding_tag_process = "Y";
      this.data_tag_process = [];
      let data = {
        event_key: this.$route.params.q,
      };
      const response = await axios.post("v1/admin/system-dashboard-tag", data);
      if (response.data.status === "success") {
        this.data_tag_process = response.data.body;
        this.is_mhao = response.data.body[0].is_mhao;
        this.mhao_price = response.data.body[0].mhao_price;
        this.is_enable_vdo = response.data.body[0].is_enable_vdo;

        this.loadding_tag_process = "N";
      } else {
        alert("systemTagProcess พบข้อผิดพลาด!");
      }
    },

    async systemTagProcessVideo() {
      this.loadding_tag_process_video = "Y";
      this.data_tag_process_video = [];
      let data = {
        event_key: this.$route.params.q,
      };
      const response = await axios.post("v1/admin/system-dashboard-tag-video", data);
      if (response.data.status === "success") {
        this.data_tag_process_video = response.data.body;

        this.loadding_tag_process_video = "N";
      } else {
        alert("systemTagProcessVideo พบข้อผิดพลาด!");
      }
    },

    async saveRoundOneAmt(_amt,_net_vat, txt_note_round1, _net_photographer, _organizershare_amt, _salespersonshare_amt, _system_amt){
      //console.log("saveRoundOneAmt",_amt,_net_vat,txt_note_round1, _net_photographer, _organizershare_amt, _salespersonshare_amt, _system_amt)
      if(confirm('คุณต้องการตัดยอดสำหรับครั้งแรก?')){
        this.loadding_report_summery = "Y";
        let data = {
          event_key: this.$route.params.q,
          amt: _amt,
          net_vat: _net_vat,
          txt_note: txt_note_round1,
          photographer_share: _net_photographer,
          sale_share: _salespersonshare_amt,
          organizer_share: _organizershare_amt,
          system_share: _system_amt
          
        };
	const headers = {
         'Authorization': 'Bearer ' + this.token
      	};
        const response = await axios.post(
          "v1/admin/save-round-one-amt",
          data,
          {
            headers
          }
        );
        if (response.data.status === "success") {
          alert(response.data.message)

          this.reportSymmery();
        } else {
          alert("saveRoundOneAmt An error has occurred. Please contact the system administrator! "+response.data.message);
        }
        }
      
    },

    async saveRoundTwoAmt(_amt,_net_vat, txt_note_round2, _net_photographer, _organizershare_amt, _salespersonshare_amt, _system_amt){
      //console.log("saveRoundTwoAmt",_amt,_net_vat,txt_note_round2, _net_photographer, _organizershare_amt, _salespersonshare_amt, _system_amt)
      if(confirm('คุณต้องการตัดยอดรอบสอง ปิดงาน?')){
        
        this.loadding_report_summery = "Y";
        let data = {
          event_key: this.$route.params.q,
          amt: _amt,
          net_vat: _net_vat,
          txt_note: txt_note_round2,
          photographer_share: _net_photographer,
          sale_share: _salespersonshare_amt,
          organizer_share: _organizershare_amt,
          system_share: _system_amt
        };
	      const headers = {
         'Authorization': 'Bearer ' + this.token
      	};
        const response = await axios.post(
          "v1/admin/save-round-two-amt",
          data,
          {
            headers
          }
        );
        if (response.data.status === "success") {
          alert(response.data.message)

          this.reportSymmery();
        } else {
          alert("saveRoundTwoAmt An error has occurred. Please contact the system administrator! "+response.data.message);
        }
        }
      
    },

    async reportSymmery() {
      this.loadding_report_summery = "Y";
      this.data_report_summery = [];
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/admin/dashboard-report-summery",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        this.data_report_summery = response.data.body;

        this.loadding_report_summery = "N";

        //load การตัดรอบแรก
        this.get_round_one_amt();
      } else {
        alert("reportSymmery พบข้อผิดพลาด! ");
      }
    },

    async get_round_one_amt(){
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/admin/get-round-one-amt",
        data,
        {
          headers
        }
      );
      if (response.data.status === "success") {
        this.data_get_round_one_amt = response.data.body[0];
      } else {
        alert("data_get_round_one_amt พบข้อผิดพลาด! ");
      }
    },
    async reportPerformance() {
      this.loadding_report_performance = "Y";
      this.data_report_performance = [];
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/admin/dashboard-report-performance",
        data,
        {
          headers
        }
      );

      if (response.data.status === "success") {
        this.data_report_performance = response.data.body;

        this.loadding_report_performance = "N";
      } else {
        alert("reportPerformance พบข้อผิดพลาด! ");
      }
    },
    async reportAccount() {
      this.data_report_account = [];
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/admin/running-user-bankaccount",
        data,
        {
          headers
        }
      );

      if (response.data.status === "success") {
        this.data_report_account = response.data.body;

      } 
    },
    async reportOrderSummery() {
      this.loadding_report_order_summery = "Y";
      this.data_report_order_summery = [];
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/admin/dashboard-report-order-summery",
        data,
        {
          headers
        }
      );

      if (response.data.status === "success") {
        this.data_report_order_summery = response.data.body;

        this.loadding_report_order_summery = "N";
      } else {
        alert("reportOrderSummery พบข้อผิดพลาด! ");
      }
    },
    async facesearchCount() {
      this.loadding_facesearch_count = "Y";
      this.data_facesearch_count = [];
      let data = {
        event_key: this.$route.params.q,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/admin/facesearch-count",
        data,
        {
          headers
        }
      );

      if (response.data.status === "success") {
        this.data_facesearch_count = response.data.body;

        this.loadding_facesearch_count = "N";
      } else {
        alert("facesearchCount พบข้อผิดพลาด! ");
      }
    },
    async verifyAccount(user_id) {
      if (!confirm("คุณต้องการยืนยันบัญชีนี้?")) {
        return;
      }
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "v1/admin/verify-user-account",
        { user_id },
        {
          headers
        }
      );
      if (response.data.status === "success") {
        this.reportAccount();
      } else {
        alert("ยืนยันบัญชีพบข้อผิดพลาด! " + response.data.message);
      }
    },
    async downloadImage(filePath) {
      const prefix = process.env.VUE_APP_SYSTEM_PREFIX || "";
      const filename = prefix + filePath.split("/").pop();
      try {
        const response = await axios.get("v1/admin/download-user-file", {
          params: { path: filePath },
          headers: { 'Authorization': 'Bearer ' + this.token },
          responseType: "blob",
        });
        const downloadUrl = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        alert("ดาวน์โหลดพบข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ");
      }
    },
  },
};
</script>
